// Regras compartilhadas entre o app (dispatch direto) e os comandos do controle remoto.

const isWaiting = (p) => p && p.teamId === 0 && p.checkedIn;

export const teamSize = (players, teamId) => players.filter((p) => p.teamId === teamId).length;

// Pode colocar o jogador no time sem passar de playersPerTeam?
export const canJoinTeam = (players, playersPerTeam, playerId, teamId) => {
  const player = players.find((p) => p.playerId === playerId);
  if (!player || !player.checkedIn || player.teamId === teamId) return false;
  if (teamId !== 1 && teamId !== 2) return false;
  return teamSize(players, teamId) < playersPerTeam;
};

// Planeja "preencher o time com vaga": escolhe o time (A no empate) e filtra os ids para
// quem ainda está na fila, sem passar da vaga. priorityIds só vale para quem continua na fila.
// Retorna { targetTeamId, playerIds, priorityIds } ou null se não há vaga.
export const planFillTeam = ({
  players, playersPerTeam, playerIds = [], priorityIds = [],
}) => {
  const aLen = teamSize(players, 1);
  const bLen = teamSize(players, 2);
  let targetTeamId = null;
  if (aLen < playersPerTeam && aLen <= bLen) targetTeamId = 1;
  else if (bLen < playersPerTeam) targetTeamId = 2;
  else if (aLen < playersPerTeam) targetTeamId = 1;
  if (!targetTeamId) return null;

  const vacancy = playersPerTeam - (targetTeamId === 1 ? aLen : bLen);
  const byId = (id) => players.find((p) => p.playerId === id);
  const fillIds = [...new Set(playerIds)].filter((id) => isWaiting(byId(id))).slice(0, vacancy);
  const fillSet = new Set(fillIds);
  return {
    targetTeamId,
    playerIds: fillIds,
    priorityIds: [...new Set(priorityIds)].filter((id) => !fillSet.has(id) && isWaiting(byId(id))),
  };
};
